import React, {useState, useEffect} from 'react'
// import "./index.scss"
import Table from 'react-bootstrap/Table'
import carets_icons from '../../assets/images/icons/carets-icon.png'
import {useDispatch, useSelector} from 'react-redux'
import {fetchPaymentsReport} from '../../actions'
import moment from 'moment'
import {useHistory} from 'react-router-dom'
import ApplicationStatusModel from '../models/applicationStatusModel'
import FirmApplicationStatusModel from "../models/firmApplicationModel";
import {FETCH_PAYMENTS_LOADING_ID} from '../../store/loaders'
import LoadingSpinner from '../../components/loadingSpiner'
import EmptyState from "../../components/EmptyState";
import empty_state_icon from '../../assets/images/empty-icon-1.png'










 const Payments = ()=>{

    const dispatch = useDispatch()
    const history = useHistory()


    const apiResponse = useSelector(state=>{
        const {paymentReport, loader} = state
        const {report} = paymentReport
        const {isLoading} = loader[FETCH_PAYMENTS_LOADING_ID] || {isLoading: false}
        return {
            report,
            isLoading
        }
    })


    const [showApplicationModel, setApplicationModel] = useState(false)
    const [showFirmModel, setFirmModel] = useState(false)
    const [modelData, setModelData] = useState('')
    const [firmData, setFirmData] = useState('')


    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    const actionLoader = apiResponse.isLoading

     useEffect(()=>{
        dispatch(fetchPaymentsReport(currentUser.sub))
     },[])


     const hanldePaymentDetails = (value)=>{
        history.push({
            pathname: '/application/status',
            state: {
                id: value.paymentReference
            }
        })
     }

     const handleApplicationModel = (data)=>{
        if(data?.itemType === "FIRM APPLICATION"){
            setFirmData(data)
            setModelData('')
            setFirmModel(true)
            return 
        }
        if(data?.itemType === "INDIVIDUAL APPLICATION"){
            setApplicationModel(true)
            setFirmData('')
            setModelData(data)
            return
        }
        setFirmModel(false)
        setApplicationModel(false)
    }

     var paymentReport
     if(apiResponse.report?.length > 0){
        paymentReport = apiResponse.report.map(value=>{
            return(
                <tr>
                <td>{moment(value.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</td>
                <td>{value.paymentReference}</td>
                <td >{value.paymentMethodName}</td>
                <td >{value.description}</td>
                <td>{value.amount}</td>
                <td className={value.status && value.status.toLowerCase()}>{value.status}</td>
                
                <td>
                    <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                        backgroundColor : 'white', border : '1px solid #00AE51'}}>
                        <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}} onClick={()=>handleApplicationModel(value)}>
                            <img style={{alignSelf : 'center'}}
                            src={require('../../assets/images/icons/icon_eye.svg').default}/>
                            <span style={{fontSize : '10px', color : '#00AE51', marginTop : '3px'}}>ref. Item</span>
                        </div>
                    </button>
                </td>
            </tr>
            )
        })
     }

    return (
        <div className="payments_wrapper">
            <div className="toolbar">
                <div className="toolbar-title">
                    <h2>Payments</h2>
                </div>
            </div>
            <br/><br/>
           { actionLoader ? 
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'}}>
                    <LoadingSpinner
                        color={'#1D834F'}/>
                </div>
           : 
           <Table striped hover responsive>
                <thead>
                        <tr>
                            <th>Date added</th>
                            <th>Ref No</th>
                            <th>
                                Payment Methods
                            </th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                </thead>
                    <tbody>
                        {paymentReport?.length > 0 ?
                            paymentReport: 
                            <tr>
                            <td colSpan={7} style={{padding: '100px 0px'}}>
                                <EmptyState
                                    header="No payments available yet"
                                    content="Available payments will be displayed here"
                                    // noImage={true}
                                    img={empty_state_icon}
                                />
                            </td>
                        </tr>
                        }
                    </tbody>
            </Table>}
            {/* <div>
                <ExportIcons/>
            </div> */}
            <ApplicationStatusModel
                show={showApplicationModel} 
                hide={handleApplicationModel}
                data={modelData} 
            />
        <FirmApplicationStatusModel
            show={showFirmModel} 
            hide={handleApplicationModel}
            data={firmData}
        />
        </div>
    )
}

export default Payments